class SoundManager {
    _music: {};
    _sfx: {};
    _scene: Phaser.Scene;
    name: string;

    constructor(name: string){
        this.name = name;
        this._music = {};
        this._sfx = {};
    }

    setScene(musicScene: Phaser.Scene){
        this._scene = musicScene;
    }

    addMusic(name:string){
        this._music[name] = this._scene.sound.add(name);
    }

    getMusic(name: string){
        return this._music[name];
    }

    playMusic(name: string, resume: boolean = true){
        Object.keys(this._music).forEach( (key) =>{
            const m = <Phaser.Sound.HTML5AudioSound>this._music[key];
            if(key === name){
                if(m.isPlaying){
                    //do nowt
                }else if(resume && m.isPaused)
                    m.resume();
                else{
                    m.play({ loop: true});
                    m.setVolume(this.musicVolume);
                }
            }else{
                m.pause();
            }
        })
    }

    pauseAllMusic(){
        Object.keys(this._music).forEach( (key) =>{
            const m = this._music[key];
            m.pause();
        });
    }

    stopAllMusic(){
        Object.keys(this._music).forEach( (key) =>{
            const m = this._music[key];
            m.stop();
        });
    }

    addSfx(name: string){
        this._sfx[name] = this._scene.sound.add(name);
    }

    getSfx(name: string){
        return this._sfx[name];
    }
    
    playSfx(key: string, subVol: number = 1,rate: number = 1){
        const sfx = this._sfx[key];
        if(sfx){
            sfx.play({ 'volume': this.sfxVolume * subVol, rate: rate });
        }
    }

    set musicVolume(v:number){
        localStorage.setItem(this.name + 'musicVolume',v.toString());
        Object.keys(this._music).forEach( (key) =>{
            const m = this._music[key];
            if(v < 0.1){
                m.setMute(true);
            }else{
                m.setMute(false);
            }
            m.setVolume(v);
        })
    }

    get musicVolume(){
        return parseFloat(localStorage.getItem(this.name + 'musicVolume')) || 0.75;
    }

    set sfxVolume(v: number){
        localStorage.setItem(this.name + 'sfxVolume',v.toString());
    }

    get sfxVolume(){
        return parseFloat(localStorage.getItem(this.name + 'sfxVolume')) || 0.75;
    }

}

export default new SoundManager("ArenaFutura");